import { initializeApp } from 'firebase/app';
import { initializeAuth, getAuth, getReactNativePersistence } from 'firebase/auth';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { Platform } from 'react-native';

// Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyCpIOvTSL2gmTuRsbPnXy_JD3LksFXFgto",
  authDomain: "fitapp-228de.firebaseapp.com",
  projectId: "fitapp-228de",
  storageBucket: "fitapp-228de.firebasestorage.app",
  messagingSenderId: "810210464418",
  appId: "1:810210464418:web:aaa369eeb37c1249cc7dfb",
  measurementId: "G-0STQFHJFWT"
};

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Initialize Auth with React Native persistence (AsyncStorage)
let auth;
if (Platform.OS === 'web') {
  auth = getAuth();
} else {
  // Use React Native persistence for native builds
  // import { getReactNativePersistence } from 'firebase/auth';
  auth = initializeAuth(app, {
    persistence: getReactNativePersistence(AsyncStorage),
  });
}

// Ensure the module is evaluated early in the app startup
// This helps avoid any accidental default Auth initialization without persistence

export { app, auth };


